import React, { useState, useEffect } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { Button, DatePicker } from "antd";
import { TfiReload } from "react-icons/tfi";
import { AiFillDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";


const Promotions = () => {
  const [search, setSearch] = useState("");
  const disableFutureDates = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.toDate() > today;
  };

  return (
    <>
      <div className="page_header">
        <h4>Promotions</h4>
      </div>

      <div className="cat_list_header">
        <div className="cat_search_box">
          <TextField
            id="custom-input"
            placeholder="search"
            variant="outlined"
            autocomplete="off"
            size="small"
            className="input_container"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              style: {
                // backgroundColor: "#ffe6e6",
                // border: "1px solid red",
              },
            }}
            FormHelperTextProps={{
              style: {
                marginTop: "0vh",
              },
            }}
          />
        </div>
        <div className="cat_lis_ad_rs">
          <DatePicker disabledDate={disableFutureDates} />
          <div className="add_lis_cls_btn">Add Promo</div>
        </div>
      </div>

      <div className="promotion_container">
        <div className="promotion_card">
          <div className="prom_head_box">
            <FiEdit className="promo_h_icon" />
            <AiFillDelete className="promo_h_icon" />
          </div>
          <div className="promo_titles">
            <span className="promp_name">Deal</span>
            <span className="promp_code">DEAL99</span>
            <span className="promp_name">Expiry Date:Oct 30</span>
          </div>
          <div className="rest_view_pr">View Restaurants</div>
          <div className="promo_ul">
            <ul>
              <li>
                <span>Valid for all users</span>
              </li>
              <li>
                <span>Min Order Amount is ₹200</span>
              </li>
              <li>
                <span>Promo quantity is 2000</span>
              </li>
            </ul>
          </div>
          <img
            className="prob_bg_img"
            src="/assets/banners/wave (2).png"
            alt="logo"
          />
        </div>
        <div className="promotion_card">
          <div className="prom_head_box">
            <FiEdit className="promo_h_icon" />
            <AiFillDelete className="promo_h_icon" />
          </div>
          <div className="promo_titles">
            <span className="promp_name">Deal</span>
            <span className="promp_code">DEAL99</span>
            <span className="promp_name">Expiry Date:Oct 30</span>
          </div>
          <div className="rest_view_pr">View Restaurants</div>
          <div className="promo_ul">
            <ul>
              <li>
                <span>Valid for all users</span>
              </li>
              <li>
                <span>Min Order Amount is ₹200</span>
              </li>
              <li>
                <span>Promo quantity is 2000</span>
              </li>
            </ul>
          </div>
          <img
            className="prob_bg_img"
            src="/assets/banners/wave (2).png"
            alt="logo"
          />
        </div>
        <div className="promotion_card">
          <div className="prom_head_box">
            <FiEdit className="promo_h_icon" />
            <AiFillDelete className="promo_h_icon" />
          </div>
          <div className="promo_titles">
            <span className="promp_name">Deal</span>
            <span className="promp_code">DEAL99</span>
            <span className="promp_name">Expiry Date:Oct 30</span>
          </div>
          <div className="rest_view_pr">View Restaurants</div>
          <div className="promo_ul">
            <ul>
              <li>
                <span>Valid for all users</span>
              </li>
              <li>
                <span>Min Order Amount is ₹200</span>
              </li>
              <li>
                <span>Promo quantity is 2000</span>
              </li>
            </ul>
          </div>
          <img
            className="prob_bg_img"
            src="/assets/banners/wave (2).png"
            alt="logo"
          />
        </div>
        <div className="promotion_card">
          <div className="prom_head_box">
            <FiEdit className="promo_h_icon" />
            <AiFillDelete className="promo_h_icon" />
          </div>
          <div className="promo_titles">
            <span className="promp_name">Deal</span>
            <span className="promp_code">DEAL99</span>
            <span className="promp_name">Expiry Date:Oct 30</span>
          </div>
          <div className="rest_view_pr">View Restaurants</div>
          <div className="promo_ul">
            <ul>
              <li>
                <span>Valid for all users</span>
              </li>
              <li>
                <span>Min Order Amount is ₹200</span>
              </li>
              <li>
                <span>Promo quantity is 2000</span>
              </li>
            </ul>
          </div>
          <img
            className="prob_bg_img"
            src="/assets/banners/wave (2).png"
            alt="logo"
          />
        </div>
      </div>
    </>
  );
};

export default Promotions;
